import { Offer } from "./Types/offerTypes";

export const offerValues: Offer = {
  name: '',
  id: 0,
  description: '',
  priceIncludes: '',
  additionalPaid: '',
  importantInformation: '',
  metaTitle: '',
  metaDescription: '',
  metaKeywords: '',
  published: false,
  displayOrder: 0,
  slug: '',
  shortDescription: '',
  hotelId: null,
  offerTypeId: 0,
  offerCategoryIds: [],
  regionId: null,
  countryId: null,
  companyId: null,
  defaultInvoiceScheme: undefined,
  offerTagIds: [],
  offerTagId: 0,
};
